import {ICON_TYPES} from '../constants';

export const SuccessTickIcon = (): JSX.Element => {
  return (
    <svg
      width='88'
      height='89'
      viewBox='0 0 88 89'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <rect y='0.5' width='88' height='88' rx='44' fill='#F3FFFB' />
      <path
        d='M37.0002 58.7163C36.3438 58.7175 35.6935 58.589 35.0869 58.3382C34.4802 58.0873 33.9291 57.7191 33.4652 57.2546L24.1436 47.9346L26.5002 45.5763L35.8219 54.898C36.1344 55.2104 36.5583 55.3859 37.0002 55.3859C37.4422 55.3859 37.866 55.2104 38.1786 54.898L61.5002 31.5763L63.8569 33.933L40.5352 57.2546C40.0713 57.7191 39.5202 58.0873 38.9136 58.3382C38.3069 58.589 37.6567 58.7175 37.0002 58.7163Z'
        fill='#005438'
      />
    </svg>
  );
};

SuccessTickIcon.iconType = ICON_TYPES.SUCCESS_TICK_ICON;
